import {MeetingParticipant} from "../Meeting";

export const isUserInMeeting = (audience: MeetingParticipant[], userId: string): boolean => {
    return audience.filter(member => member.userId.toUpperCase() === userId.toUpperCase()).length > 0
}